import { render, staticRenderFns } from "./UploadAnexoComAcoes.vue?vue&type=template&id=fa4e5572&scoped=true"
import script from "./UploadAnexoComAcoes.vue?vue&type=script&lang=ts"
export * from "./UploadAnexoComAcoes.vue?vue&type=script&lang=ts"
import style0 from "./UploadAnexoComAcoes.vue?vue&type=style&index=0&id=fa4e5572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4e5572",
  null
  
)

export default component.exports